import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useFingerPrint } from '~/components/FingerPrintProvider';
import { Input } from '~/elements/Input';
import styles from '~/components/RegisterForm/registerForm.module.css';
import Loader from '~/elements/Loader';
import { getEvent } from '~/selectors/event';
import { connect } from 'react-redux';
import { fullNameSchema } from '~/utils/validation';
const schema = yup.object({
    fullName: fullNameSchema.required('Name is required'),
    tandc: yup
        .bool()
        .oneOf([true], 'Please agree to the T&C and Privacy Policy')
        .required('Please agree to the T&C and Privacy Policy'),
});
const NameOnly = (props) => {
    const [loading, setLoading] = React.useState(false);
    const { fingerprint } = process.env.NODE_ENV === 'test'
        ? {
            fingerprint: 'mockFingerPrint',
        }
        : useFingerPrint();
    const { control, handleSubmit } = useForm({
        resolver: yupResolver(schema),
    });
    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        try {
            setLoading(false);
            props.onRegister();
        }
        catch (error) {
            setLoading(false);
        }
    });
    return (_jsxs("form", { className: styles.form, onSubmit: onSubmit, children: [_jsx(Input, { label: "Name", name: "fullName", control: control, isRequired: true }), _jsx(Input, { label: "Terms and Conditions", name: "tandc", control: control, type: "checkbox", children: _jsxs("div", { className: styles.termsAndConditions, children: ["I agree to the", ' ', _jsx("a", { href: "https://www.oneroomstreaming.com/terms-and-conditions", target: "_blank", rel: "noreferrer", children: "T & C" }), ' ', "and", ' ', _jsx("a", { href: "https://www.oneroomstreaming.com/privacy-policy", target: "_blank", rel: "noreferrer", children: "Privacy Policy" })] }) }), _jsx("button", { className: styles.registerButton, disabled: loading, children: loading ? _jsx(Loader, { size: 24, color: "white" }) : 'Submit' })] }));
};
const mapStateToProps = (state) => ({
    event: getEvent(state),
});
export default connect(mapStateToProps)(NameOnly);
